// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-20e30220] .dialog {\n  width: 900px;\n}\n[data-v-20e30220] .el-dialog {\n  margin-top: 1vh !important;\n}\n.link[data-v-20e30220] {\n  color: #409EFF;\n  cursor: pointer;\n  margin-left: 15px;\n}", ""]);
// Exports
module.exports = exports;
